<template>
  <div id="app" class="min-h-screen">
    <NavBar />
    <router-view />
    <Footer />

    <ImageViewer :image="currentImage" @close="currentImage = null" />

    <CookieBanner :googleTagManagerId="googleTagManagerId" />
  </div>
</template>

<script setup>

import { provide, ref } from 'vue'

import NavBar from '@/components/NavBar.vue'
import Footer from '@/components/Footer.vue'
import ImageViewer from '@/components/ImageViewer.vue'
import CookieBanner from '@/components/CookieBanner/CookieBanner.vue'

const googleTagManagerId = ref('GTM-MF752MRW');

//Image viewer
const currentImage = ref(null)
provide('viewImage', viewImage)

function viewImage(image) {
  currentImage.value = image
}

</script>

<style>
.reveal {
  opacity: 0;
  transform: translateY(32px);
  transition: opacity 600ms ease, transform 600ms ease;
  will-change: opacity, transform;
}

.reveal--in {
  opacity: 1;
  transform: translateY(0);
}

@media (prefers-reduced-motion: reduce) {
  .reveal {
    transition: none;
    transform: none;
  }
}
</style>